import {URL} from '@netx/core-next/url';

export const getViewPath = (assetId: number) =>
	`${URL.assetEndpoint}/${assetId}/view`;
